import Loader from '~/components/Loading/Splash'
import Loadable from '~/utils/loadable'

export default Loadable({
  loader: () => import('./Router'),
  loading: Loader,
})
